import { HStack, Text, Tooltip } from '@chakra-ui/react'
import { useTranscription } from '@daily-co/daily-react'
import React from 'react'
import { AudioIndicator } from './audio-indicator'

export const ClientTranscriptionIndicator = () => {
  const { isTranscribing } = useTranscription()

  return (
    <Tooltip label="Your session is being transcribed securely to help your clinician take accurate notes. Your data is private and protected.">
      <HStack
        spacing="4px"
        bg="#282828"
        p="4px"
        pr="xsmall"
        borderRadius="8px"
        whiteSpace="nowrap"
        h="32px"
        w={'100%'}
      >
        <AudioIndicator isTranscribing={isTranscribing} />
        <Text pl="4px" color="#757575" fontSize="12px">
          {isTranscribing ? 'Taking notes...' : 'Paused...'}
        </Text>
      </HStack>
    </Tooltip>
  )
}
